
/**
 * ä½¿ç¨æ¹æ³ï¼
 * [comob-lookup-data-mapping]="{ id: 'user.userId', name: 'user.userName' }"
 * key ä¸ºå¸®å©ä¸çå­æ®µï¼ value ä¸º è¡¨åä¸­çå­æ®µå
 * å¸®å©ä¸çåä¸ä¸ªå­æ®µå¯ä»¥æ å°å°è¡¨åä¸­çå¤ä¸ªå­æ®µä¸­ï¼{ ... id: 'user.userid, user.addusid'}
 * å¤å­æ®µä»¥éå·éå¼
 *
 */

import { Directive, OnInit, Optional, Self, Input } from '@angular/core';
import { BindingObject, NgFormControl, ViewModel } from '@farris/devkit';
import { ComboChanges } from '@farris/ui-combo-list';
import { ComboLookupComponent } from '@farris/ui-combo-lookup';
import { DataMapping } from './data-mapping';


@Directive({ selector: '[combo-lookup-data-mapping]' })
export class ComboLookupDataMappingDirective extends DataMapping implements OnInit {
  @Input('combo-lookup-data-mapping') mapfields: any;
  @Input('target') target: BindingObject = null;

  constructor(@Optional() public vm: ViewModel, @Optional() @Self() private lookup: ComboLookupComponent) {
    super();
    if (this.lookup) {
      this.lookup.useFormDataMapping = true;
    }
  }

  ngOnInit() {
    // å¤æ­åè°ä¸­æ¯å¦æææ¬å­æ®µæ å°
    const lookupInstance = this.lookup;
    const { textField } = lookupInstance;
    if (this.mapfields) {
      delete this.mapfields[textField];
    }
    // å¼ååï¼äº¦éè¿è¯¥äºä»¶è§¦åä»»æè¾å¥æ¸ç©ºäºä»¶
    this.lookup.valueChange.subscribe((result: ComboChanges & { instance: ComboLookupComponent; }) => {
      if (!result['nosearch']) {
        // å¼åå
        const data = result.selections && result.selections.length > 0 ? result.selections : null;
        this.onValueChange(data);
      } else {
        // ä»»æè¾å¥æ¸ç©ºæ å°å­æ®µ
        this.onClearMapping();
      }
    });
    // æ¸ç©ºäºä»¶
    this.lookup.clear.subscribe(() => {
      const _mapfields = this.mapfields || this.lookup.mapFields;
      this.mappingData(null, _mapfields);
    });
  }
  private onClearMapping() {
    const mapfields = Object.assign({}, (this.mapfields || this.lookup.mapFields || {}));
    const lookupTextField = this.lookup.textField;
    const data = {};
    const controlName = this.lookup.ngControl && this.lookup.ngControl.name;
    if (controlName && this.vm) {
      const textFieldMapping = mapfields[lookupTextField];
      const ngFormControl = this.vm && this.vm.form && this.vm.form.ngFormControls && this.vm.form.ngFormControls[controlName] as NgFormControl;
      const binding = ngFormControl && ngFormControl.binding;
      if (textFieldMapping && binding) {
        const targetField = textFieldMapping.split(',').filter((item) => item !== binding).join(',');
        if (targetField) {
          mapfields[lookupTextField] = targetField;
        } else {
          delete mapfields[lookupTextField];
        }
      }
    }
    if (mapfields && Object.keys(mapfields).length > 0) {
      Object.keys(mapfields).forEach((field) => {
        this.setValue(data, field.split('.'), '');
      });
      this.mappingData(data, mapfields, true);
    }
  }
  private onValueChange(data) {
    const _mapfields = this.mapfields || this.lookup.mapFields;
    const spliter = this.lookup.separator || this.defaultSpliter;
    this.mappingData(data, _mapfields, false, spliter);
  }
}
